var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxsFilePdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-587 439 24 24",
    style: {
      enableBackground: "new -587 439 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7C7B7B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-578.7,453.7c-0.2,0-0.3,0-0.4,0v1.2c0.1,0,0.2,0,0.3,0c0.5,0,0.8-0.2,0.8-0.7 C-578,453.9-578.3,453.7-578.7,453.7z M-575.2,453.7c-0.2,0-0.3,0-0.4,0v2.6c0.1,0,0.2,0,0.3,0c0.8,0,1.3-0.4,1.3-1.4 C-574,454.1-574.5,453.7-575.2,453.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-573,441h-8c-1.1,0-2,0.9-2,2v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-12L-573,441z M-577.5,455.2 c-0.3,0.3-0.8,0.4-1.3,0.4c-0.1,0-0.2,0-0.3,0v1.4h-0.9v-3.9c0.4-0.1,0.8-0.1,1.2-0.1c0.6,0,1,0.1,1.2,0.3c0.3,0.2,0.4,0.5,0.4,0.9 C-577.1,454.6-577.3,455-577.5,455.2z M-573.7,456.5c-0.4,0.3-1.1,0.5-1.8,0.5c-0.5,0-0.8,0-1-0.1v-3.9c0.4-0.1,0.8-0.1,1.2-0.1 c0.8,0,1.2,0.1,1.6,0.4c0.4,0.3,0.7,0.8,0.7,1.5C-573,455.7-573.3,456.2-573.7,456.5z M-570,453.8h-1.5v0.9h1.4v0.7h-1.4v1.6h-0.9 v-4h2.4C-570,453-570,453.8-570,453.8z M-573,448h-1v-5l5,5H-573z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsFilePdf);
export default __webpack_public_path__ + "static/media/bxs-file-pdf.f6001d5a55a53a7c8260a21b24d93fd3.svg";
export { ForwardRef as ReactComponent };